<template>
<div>
<section class="hero is-small is-light">
  <div class="hero-body">
    <div class="container">
      <h1 class="title">
        Mr. Mustache's Kaffeeliste
      </h1>
      <h2 class="subtitle">
        Enterprise (<span role="image" aria-label="hamburger">🤓</span>) Coffee Management
      </h2>
    </div>
  </div>
</section>

<section class="section">
  <div class="container">
    <div class="columns is-multiline is-mobile">
      <div class="column is-half is-offset-one-quarter">
       <!-- <div class="has-text-centered"> -->
        <router-link class="button is-large is-fullwidth is-warning" to="/order/select"><span class="icon is-hidden-mobile"><i class="fa fa-coffee"></i></span><span>Neuer Kaffee</span></router-link>
      </div>
    </div>
    
  </div>
  </section>

</div>
</template>

<script>
import { Auth, Hub } from 'aws-amplify';
import AmplifyStore from '../store';

export default {
  name: 'home',
  data() {
    return {
    }
  },
  computed: {
    user() { 
      return AmplifyStore.state.user
    }
  }, 
  async mounted() {
    //console.log(this.user);

    //console.log(await Auth.currentUserInfo());
  }
}
</script>

<style lang="scss">
//.has-bg-img { background: url('../assets/attraktiv-cafe-dame-544117.jpg')center center; background-size:cover; }
</style>



